var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClockIcon = function SvgClockIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "{50} ",
    height: "{50} ",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\\\\\\\xE2ngulo 2007",
    fill: "none",
    d: "M0 0h32.258v37.819H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\\\\\\\xE2ngulo 2009",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: "{0.5} ",
    d: "M0 0h7.35v9.828H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\\\\\\\xE2ngulo 2008",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: "{1.7} ",
    d: "M0 0h31.026v33.253H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5748"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ret\\\\\\\\xE2ngulo 1976",
    fill: "#fff",
    opacity: "{0.8} ",
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5736"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5735",
    clipPath: "url(#a)",
    transform: "translate(8.871 6.09)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4692",
    d: "M31.456 3.773 26.663.356a1.913 1.913 0 1 0-2.221 3.114l4.793 3.417a1.913 1.913 0 0 0 2.221-3.114Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4693",
    d: "m3.024 6.888 4.791-3.417A1.913 1.913 0 1 0 5.594.356L.8 3.773a1.914 1.914 0 0 0 2.224 3.115Z",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5738",
    clipPath: "url(#b)",
    transform: "translate(14.596 11.777)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4696",
    d: "M5.814 6.756H3.057V1.528a1.529 1.529 0 0 0-3.057 0v6.756a1.533 1.533 0 0 0 1.522 1.544h4.292a1.536 1.536 0 0 0 0-3.072",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: "{0.5} "
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 5737",
    clipPath: "url(#c)",
    transform: "translate(9.488 10.656)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 4695",
    d: "M31.026 15.523A15.513 15.513 0 1 0 5.185 27.088l-2.206 3.2a1.91 1.91 0 0 0 3.152 2.154l2.19-3.183a15.42 15.42 0 0 0 14.386 0l2.19 3.183a1.91 1.91 0 0 0 3.151-2.159l-2.19-3.2a15.512 15.512 0 0 0 5.168-11.566Zm-15.5 11.234a11.227 11.227 0 1 1 11.215-11.239v.005a11.263 11.263 0 0 1-11.219 11.234",
    fill: "#4b4b4b",
    stroke: "#fff",
    strokeWidth: "{1.7} "
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClockIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock-icon.30937b56.svg";
export { ForwardRef as ReactComponent };